export default function genererProduitConcessionnaire() {
  return {
    tiersId: null,
    pourcentage: 0,
  };
}
